import { DomainFilterType } from "../model/enum/observations/domain-filter-type.enum";
import { Subdomain } from "../model/enum/observations/subdomain.enum";
import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const RubricObservationLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates, 
    rubricDetails: LazyLoadedStates 
}> ({
    base: {
        name: 'authenticated.user-summary.rubric',
        url: '/rubric',
        abstract: true
    },
    rubricDetails: {
        name: 'authenticated.user-summary.rubric.details',
        url: '/details/:userId/:observationId?filterType&currentRubricComponent',
        params: {
            filterType: {
                raw: true,
                dynamic: true,
                type: 'int',
                value: DomainFilterType.COMPONENT
            },
            currentRubricComponent: {
                raw: true,
                dynamic: true,
                type: 'string',
                value: Subdomain.CONTENT_KNOWLEDGE
            },
            showTargetUser: {
                raw: true,
                dynamic: true,
                type: 'bool'
            },
            canShowHistorical: {
                raw: true,
                dynamic: true,
                type: 'bool',
                value: false
            },
        }
    }
},
() => import('src/app/observations/rubric/rubric.module')
    .then((result: { RubricModule: any }) => result.RubricModule));
